import { Grid, List, ListItem, Menu, Typography } from "@mui/material";
import { withStyles, WithStyles } from "@mui/styles";
import * as coreApi from "api/Core";
import { AppImages } from "assets/appResources";
import { FilterBarStyleClasses, GlobalClassKeys, GlobalSearchStyleClasses } from "assets/jss/common-styles";
import ButtonClear from "components/Buttons/ButtonClear";
import ButtonDropdown from "components/Buttons/ButtonDropdown";
import ButtonOrderBy from "components/Buttons/ButtonOrderBy";
import { SpinnerIndicator } from "components/CallServer";
import DateRangePickerDialog from "components/DateRangePickerDialog";
import FilterCountInfo from "components/FilterCountInfo";
import { MuiFilterAppBar, MuiFilterLine, MuiFilterToolbar } from "components/MuiExtras/Filter";
import MuiMessageBox from "components/MuiExtras/MessageBox/MuiMessageBox";
import MuiContainer from "components/MuiExtras/MuiContainer";
import MuiMenuItemChecked from "components/MuiExtras/MuiMenuItemChecked";
import MuiPagination from "components/MuiExtras/MuiPagination";
import MuiPaper from "components/MuiExtras/MuiPaper";
import MuiPushRight from "components/MuiExtras/MuiPushRight";
import MuiMuted from "components/MuiExtras/Typography/MuiMuted";
import AppResource from "components/Translations/AppResources";
import PublicationTypeName from "components/Translations/PublicationTypeName";
import { Formaters } from "lib/Formarters";
import { PublicationType } from "models/ApiEnums";
import { GlobalPublicationSearchFilter, GlobalSearchContent, GlobalSearchPublicationOrderBy, GlobalSearchPublicationPeriod, GlobalSearchResult } from "models/ApiModels";
import queryString from 'query-string';
import * as React from "react";
import { Trans, WithTranslation, withTranslation } from "react-i18next";
import { RouteComponentProps } from "react-router";
import { Link } from "react-router-dom";
import { RoutePaths } from "routes/RouteConfig";
import { SearchRenderCourse } from "views/Search/Components/SearchRenderCourse";
import { SearchRenderDocument } from "views/Search/Components/SearchRenderDocument";
import { SearchRenderPublication } from "./Components/SearchRenderPublication";
import { SearchRenderTopic } from "./Components/SearchRenderTopic";
import { SearchRenderUser } from "./Components/SearchRenderUser";

/////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
    dialog: any;
    loading: boolean;
    searchResult: GlobalSearchResult;
    recordsLoaded: number;
    lastOffset: number;

    orderByMenuAnchorEl: any;
    publicationTypeMenuAnchorEl: any;
    contentTypeMenuAnchorEl: any;
    periodMenuAnchorEl: any;

    lastError: any;

    customStartDate: Date;
    customEndDate: Date;
}

interface IProps {
}

type Props = IProps & RouteComponentProps<{}> & WithStyles<typeof FilterBarStyleClasses> & WithStyles<typeof GlobalSearchStyleClasses> & WithTranslation;

export const GlobalSearchFirstPageRowsPerPage = 5;
export const GlobalSearchRowsPerPage = 10;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export class FullGlobalSearch extends React.Component<Props, IState> {
    private filter: GlobalPublicationSearchFilter;
    private orderBy: GlobalSearchPublicationOrderBy = GlobalSearchPublicationOrderBy.MostRelevant;

    constructor(props: Props) {
        super(props);
        this.state = {
            dialog: null,
            searchResult: null,
            recordsLoaded: 0,
            lastOffset: 0,
            orderByMenuAnchorEl: null,
            publicationTypeMenuAnchorEl: null,
            contentTypeMenuAnchorEl: null,
            periodMenuAnchorEl: null,
            loading: true,
            lastError: null,
            customEndDate: null,
            customStartDate: null
        };
        this.clearFilter(props);
    }


    //#region FILTER

    private renderAdvFilter(): JSX.Element {

        const filtered = this.filter.publicationType != null
            || this.filter.content != GlobalSearchContent.All
            || this.filter.period != GlobalSearchPublicationPeriod.Any;

        return (
            <MuiFilterAppBar position="static">
                <MuiFilterToolbar variant="dense" >
                    <MuiFilterLine>
                        <div>
                            <ButtonDropdown
                                simple
                                text={this.getPublicationTypeName(this.filter.publicationType)}
                                color={this.filter.publicationType == null ? "inherit" : "warning"}
                                onClick={(e) => { this.setState({ publicationTypeMenuAnchorEl: e.currentTarget }); }}
                            />
                            <Menu
                                id="simple-menu"
                                anchorEl={this.state.publicationTypeMenuAnchorEl}
                                open={this.state.publicationTypeMenuAnchorEl != null}
                                onClose={() => { this.setState({ publicationTypeMenuAnchorEl: null }); }}
                            >
                                <MuiMenuItemChecked text={this.getPublicationTypeName(0)} value={null} currentSelection={this.filter.publicationType} onClick={this.applyPublicationType} />
                                <MuiMenuItemChecked text={this.getPublicationTypeName(PublicationType.Post)} value={PublicationType.Post} currentSelection={this.filter.publicationType} onClick={this.applyPublicationType} />
                                <MuiMenuItemChecked text={this.getPublicationTypeName(PublicationType.Question)} value={PublicationType.Question} currentSelection={this.filter.publicationType} onClick={this.applyPublicationType} />
                                <MuiMenuItemChecked text={this.getPublicationTypeName(PublicationType.List)} value={PublicationType.List} currentSelection={this.filter.publicationType} onClick={this.applyPublicationType} />
                                <MuiMenuItemChecked text={this.getPublicationTypeName(PublicationType.Poll)} value={PublicationType.Poll} currentSelection={this.filter.publicationType} onClick={this.applyPublicationType} />
                            </Menu>
                        </div>

                        <div>
                            <ButtonDropdown
                                simple
                                text={this.getContentName(this.filter.content == GlobalSearchContent.All ? null : this.filter.content)}
                                color={this.filter.content == GlobalSearchContent.All ? "inherit" : "warning"}
                                onClick={(e) => { this.setState({ contentTypeMenuAnchorEl: e.currentTarget }); }}
                            />
                            <Menu
                                id="simple-menu"
                                anchorEl={this.state.contentTypeMenuAnchorEl}
                                open={this.state.contentTypeMenuAnchorEl != null}
                                onClose={() => { this.setState({ contentTypeMenuAnchorEl: null }); }}
                            >
                                <MuiMenuItemChecked text={this.getContentName(GlobalSearchContent.All)} value={GlobalSearchContent.All} currentSelection={this.filter.content} onClick={this.applyContent} />
                                <MuiMenuItemChecked text={this.getContentName(GlobalSearchContent.Video)} value={GlobalSearchContent.Video} currentSelection={this.filter.content} onClick={this.applyContent} />
                                <MuiMenuItemChecked text={this.getContentName(GlobalSearchContent.Image)} value={GlobalSearchContent.Image} currentSelection={this.filter.content} onClick={this.applyContent} />
                                <MuiMenuItemChecked text={this.getContentName(GlobalSearchContent.File)} value={GlobalSearchContent.File} currentSelection={this.filter.content} onClick={this.applyContent} />
                                {
                                    this.filter.publicationType == PublicationType.Question &&
                                    <MuiMenuItemChecked text={this.getContentName(GlobalSearchContent.WithAnswer)} value={GlobalSearchContent.WithAnswer} currentSelection={this.filter.content} onClick={this.applyContent} />
                                }
                            </Menu>
                        </div>

                        <div>
                            <ButtonDropdown
                                simple
                                text={this.getPeriodName(this.filter.period == 0 ? null : this.filter.period)}
                                color={this.filter.period == GlobalSearchPublicationPeriod.Any ? "inherit" : "warning"}
                                onClick={(e) => { this.setState({ periodMenuAnchorEl: e.currentTarget }); }}
                            />
                            <Menu
                                id="simple-menu"
                                anchorEl={this.state.periodMenuAnchorEl}
                                open={this.state.periodMenuAnchorEl != null}
                                onClose={() => { this.setState({ periodMenuAnchorEl: null }); }}
                            >
                                <MuiMenuItemChecked text={this.getPeriodName(GlobalSearchPublicationPeriod.Any)} value={GlobalSearchPublicationPeriod.Any} currentSelection={this.filter.period} onClick={this.applyPeriod} />
                                <MuiMenuItemChecked text={this.getPeriodName(GlobalSearchPublicationPeriod.Today)} value={GlobalSearchPublicationPeriod.Today} currentSelection={this.filter.period} onClick={this.applyPeriod} />
                                <MuiMenuItemChecked text={this.getPeriodName(GlobalSearchPublicationPeriod.LastWeek)} value={GlobalSearchPublicationPeriod.LastWeek} currentSelection={this.filter.period} onClick={this.applyPeriod} />
                                <MuiMenuItemChecked text={this.getPeriodName(GlobalSearchPublicationPeriod.LastMonth)} value={GlobalSearchPublicationPeriod.LastMonth} currentSelection={this.filter.period} onClick={this.applyPeriod} />
                                <MuiMenuItemChecked text={this.getPeriodName(GlobalSearchPublicationPeriod.LastQuarter)} value={GlobalSearchPublicationPeriod.LastQuarter} currentSelection={this.filter.period} onClick={this.applyPeriod} />
                                <MuiMenuItemChecked text={this.getPeriodName(GlobalSearchPublicationPeriod.LastYear)} value={GlobalSearchPublicationPeriod.LastYear} currentSelection={this.filter.period} onClick={this.applyPeriod} />
                                <MuiMenuItemChecked text={this.getPeriodName(GlobalSearchPublicationPeriod.Custom)} value={GlobalSearchPublicationPeriod.Custom} currentSelection={this.filter.period} onClick={this.getCustomDate} />
                            </Menu>
                        </div>

                        {
                            filtered &&
                            <div>
                                <ButtonClear
                                    simple
                                    color={"warning"}
                                    onClick={(e) => { this.reset(this.props); }}
                                />
                            </div>
                        }

                        <MuiPushRight>
                            <ButtonOrderBy
                                text={this.getOrderByName(this.orderBy)}
                                onClick={(e) => { this.setState({ orderByMenuAnchorEl: e.currentTarget }); }}
                            />

                            <Menu
                                id="simple-menu"
                                anchorEl={this.state.orderByMenuAnchorEl}
                                open={this.state.orderByMenuAnchorEl != null}
                                onClose={() => { this.setState({ orderByMenuAnchorEl: null }); }}
                            >
                                <MuiMenuItemChecked text={this.getOrderByName(GlobalSearchPublicationOrderBy.MostRelevant)} value={GlobalSearchPublicationOrderBy.MostRelevant} currentSelection={this.orderBy} onClick={this.applyOrder} />
                                <MuiMenuItemChecked text={this.getOrderByName(GlobalSearchPublicationOrderBy.MostLiked)} value={GlobalSearchPublicationOrderBy.MostLiked} currentSelection={this.orderBy} onClick={this.applyOrder} />
                                <MuiMenuItemChecked text={this.getOrderByName(GlobalSearchPublicationOrderBy.MostRecent)} value={GlobalSearchPublicationOrderBy.MostRecent} currentSelection={this.orderBy} onClick={this.applyOrder} />
                                <MuiMenuItemChecked text={this.getOrderByName(GlobalSearchPublicationOrderBy.MostViewed)} value={GlobalSearchPublicationOrderBy.MostViewed} currentSelection={this.orderBy} onClick={this.applyOrder} />
                            </Menu>
                        </MuiPushRight>
                    </MuiFilterLine>
                </MuiFilterToolbar>
            </MuiFilterAppBar>
        );
    }

    private getCustomDate = () => {
        this.setState({
            periodMenuAnchorEl: null,
            dialog: <DateRangePickerDialog
                startDate={this.filter.periodCustomStart}
                endDate={this.filter.periodCustomEnd}
                onSelect={
                    (result) => {
                        this.setState({ dialog: null });

                        if (result == null) {
                            this.filter.periodCustomEnd = this.filter.periodCustomStart = null;
                            this.applyPeriod(GlobalSearchPublicationPeriod.Any);
                        }
                        else {
                            this.filter.periodCustomEnd = result.end;
                            this.filter.periodCustomStart = result.start;
                            this.applyPeriod(GlobalSearchPublicationPeriod.Custom);
                        }
                    }
                }
            />
        });
    };

    private getPublicationTypeName(p: PublicationType) {
        if (p == null) return this.props.t("Common.Filter.Toolbar.PublicationType.NotDefined");
        if ((p as number) == 0) return this.props.t("Common.Filter.Toolbar.PublicationType.Any");
        return <PublicationTypeName publicationType={p} />;
    }

    private getPeriodName(p: GlobalSearchPublicationPeriod): string {
        if (p == null) return this.props.t("Common.Filter.Toolbar.Period.NotDefined");
        switch (p) {
            case GlobalSearchPublicationPeriod.Any: return this.props.t("Common.Filter.Toolbar.Period.Any");
            case GlobalSearchPublicationPeriod.Today: return this.props.t("Common.Filter.Toolbar.Period.Today");
            case GlobalSearchPublicationPeriod.LastWeek: return this.props.t("Common.Filter.Toolbar.Period.LastWeek");
            case GlobalSearchPublicationPeriod.LastMonth: return this.props.t("Common.Filter.Toolbar.Period.LastMonth");
            case GlobalSearchPublicationPeriod.LastQuarter: return this.props.t("Common.Filter.Toolbar.Period.LastQuarter");
            case GlobalSearchPublicationPeriod.LastYear: return this.props.t("Common.Filter.Toolbar.Period.LastYear");
            case GlobalSearchPublicationPeriod.Custom:
                return this.filter.periodCustomStart == null
                    ? this.props.t("Common.Filter.Toolbar.Period.Custom") + "..."
                    : Formaters.dateRange(this.filter.periodCustomStart, this.filter.periodCustomEnd);
        }
        return "?";
    }

    private getContentName(p: GlobalSearchContent): string {
        if (p == null) return this.props.t("Common.Filter.Toolbar.Content.NotDefined");

        switch (p) {
            case GlobalSearchContent.All: return this.props.t("Common.Filter.Toolbar.Content.Any");
            case GlobalSearchContent.File: return this.props.t("Common.Filter.Toolbar.Content.File");
            case GlobalSearchContent.Image: return this.props.t("Common.Filter.Toolbar.Content.Image");
            case GlobalSearchContent.Video: return this.props.t("Common.Filter.Toolbar.Content.Video");
            case GlobalSearchContent.WithAnswer: return this.props.t("Common.Filter.Toolbar.Content.WithAnswer");
        }
        return "?";
    }

    private getOrderByName(o: GlobalSearchPublicationOrderBy): string {
        switch (o) {
            case GlobalSearchPublicationOrderBy.MostLiked: return this.props.t("Common.Filter.Toolbar.OrderBy.MostLiked");
            case GlobalSearchPublicationOrderBy.MostRecent: return this.props.t("Common.Filter.Toolbar.OrderBy.MostRecent");
            case GlobalSearchPublicationOrderBy.MostViewed: return this.props.t("Common.Filter.Toolbar.OrderBy.MostViewed");
            case GlobalSearchPublicationOrderBy.MostRelevant: return this.props.t("Common.Filter.Toolbar.OrderBy.MostRelevant");
        }
        return "?";
    }

    private reset(p: Props) {
        this.clearFilter(p);
        this.firstLoad();
    }

    private clearFilter(p: Props) {
        const values = queryString.parse(p.location.search);
        var searchText = decodeURIComponent(values.q as string);
        this.filter = {
            searchText: searchText,
            period: GlobalSearchPublicationPeriod.Any,
            content: GlobalSearchContent.All,
            publicationType: null,
            specialistOnly: null,
        };
    }

    private applyOrder = (orderBy: GlobalSearchPublicationOrderBy) => {
        this.orderBy = orderBy;
        this.firstLoad();
    };

    private applyContent = (content: GlobalSearchContent) => {
        this.filter.content = content;
        this.firstLoad();
    };

    private applyPublicationType = (publicationType: PublicationType) => {
        this.filter.publicationType = publicationType == null || (publicationType as number) == 0 ? null : publicationType;

        if (this.filter.content == GlobalSearchContent.WithAnswer && this.filter.publicationType != PublicationType.Question)
            this.filter.content = GlobalSearchContent.All;

        this.firstLoad();
    };

    private applyPeriod = (period: GlobalSearchPublicationPeriod) => {
        if (period != GlobalSearchPublicationPeriod.Custom) {
            this.filter.periodCustomEnd = this.filter.periodCustomStart = null;
        }
        this.filter.period = period;
        this.firstLoad();
    };

    //#endregion


    private firstLoad() {

        this.setState({
            loading: true,
            searchResult: null,
            lastError: null,
            orderByMenuAnchorEl: null,
            contentTypeMenuAnchorEl: null,
            publicationTypeMenuAnchorEl: null,
            periodMenuAnchorEl: null
        });

        coreApi.globalSearch(this.filter, this.orderBy, 0, GlobalSearchRowsPerPage, GlobalSearchFirstPageRowsPerPage)
            .then((result) => {
                this.setState({ searchResult: result, loading: false, lastOffset: 0 });
            })
            .catch((lastError) => {
                this.setState({ lastError: lastError.message || lastError, loading: false });
            });
    }

    private loadPublications(offset: number) {

        this.setState({
            loading: true,
            lastError: null,
            orderByMenuAnchorEl: null,
            contentTypeMenuAnchorEl: null,
            publicationTypeMenuAnchorEl: null,
            periodMenuAnchorEl: null
        });

        coreApi.globalSearchPublications(
            this.filter,
            this.orderBy,
            offset,
            GlobalSearchRowsPerPage
        )
            .then((result) => {
                var searchResult = Object.assign({}, this.state.searchResult);
                searchResult.publications.items = result.items;
                searchResult.publications.totalRecords = result.totalRecords;

                this.setState({
                    loading: false,
                    searchResult,
                    lastOffset: offset
                });
            })
            .catch((lastError) => {
                this.setState({ lastError: lastError.message || lastError, loading: false });
            });
    }

    private firstPageRender() {
        const { searchResult } = this.state;

        return (
            <>
                {
                    searchResult.users.totalRecords > 0 &&
                    <MuiContainer>
                        <MuiPaper paperColor="white" className={this.props.classes.userCard}>
                            <List>
                                {
                                    //Se quiser usar divisor: showDivider={index < searchResult.users.items.length - 1 || searchResult.users.totalRecords > GlobalSearchFirstPageRowsPerPage}
                                    searchResult.users.items.map((v, index) => {
                                        return <SearchRenderUser
                                            data={v}
                                            index={index}
                                            key={index}
                                            showDivider={false}
                                        />;
                                    })
                                }
                            </List>
                            {
                                searchResult.users.totalRecords > GlobalSearchFirstPageRowsPerPage &&
                                <Link className={GlobalClassKeys.link} to={RoutePaths.FullUserSearch + this.props.location.search}><AppResource resource="Views.Search.FullGlobalSearch.ShowMoreUsers" /></Link>
                            }
                        </MuiPaper>
                    </MuiContainer>
                }

                {
                    searchResult.topics.totalRecords > 0 &&
                    <MuiContainer>
                        <MuiPaper paperColor="white" className={this.props.classes.topicCard}>
                            <List>
                                {
                                    //Se quiser usar divisor: showDivider={index < searchResult.topics.items.length - 1 || searchResult.topics.totalRecords > GlobalSearchFirstPageRowsPerPage}
                                    searchResult.topics.items.map((v, index) => {
                                        return <SearchRenderTopic
                                            data={v}
                                            index={index}
                                            key={index}
                                            showDivider={false}
                                        />;
                                    })
                                }
                            </List>
                            {
                                searchResult.topics.totalRecords > GlobalSearchFirstPageRowsPerPage &&
                                <Link className={GlobalClassKeys.link} to={RoutePaths.FullTopicSearch + this.props.location.search}><AppResource resource="Views.Search.FullGlobalSearch.ShowMoreTopics" /></Link>
                            }
                        </MuiPaper>
                    </MuiContainer>
                }

                {
                    searchResult.courses.totalRecords > 0 &&
                    <MuiContainer>
                        <MuiPaper paperColor="white" className={this.props.classes.courseCard}>
                            <List>
                                {
                                    //Se quiser usar divisor: showDivider={index < searchResult.courses.items.length - 1 || searchResult.courses.totalRecords > GlobalSearchFirstPageRowsPerPage}
                                    searchResult.courses.items.map((v, index) => {
                                        return <SearchRenderCourse
                                            data={v}
                                            index={index}
                                            key={index}
                                            showDivider={false}
                                            {...this.props}
                                        />;
                                    })
                                }
                            </List>
                            {
                                searchResult.courses.totalRecords > GlobalSearchFirstPageRowsPerPage &&
                                <Link className={GlobalClassKeys.link} to={RoutePaths.FullCourseSearch + this.props.location.search}><AppResource resource="Views.Search.FullGlobalSearch.ShowMoreCourses" /></Link>
                            }
                        </MuiPaper>
                    </MuiContainer>
                }

                {
                    searchResult.documents.totalRecords > 0 && searchResult.publications.totalRecords == 0 &&
                    <MuiContainer>
                        <MuiPaper paperColor="white" className={this.props.classes.documentCard}>
                            <List>
                                {
                                    //Se quiser usar divisor: showDivider={index < searchResult.documents.items.length - 1 || searchResult.documents.totalRecords > GlobalSearchFirstPageRowsPerPage}
                                    searchResult.documents.items.map((v, index) => {
                                        return <SearchRenderDocument
                                            key={v.id}
                                            data={v}
                                            index={index}
                                            showDivider={false}
                                            querySearch={this.filter.searchText}
                                        />;
                                    })
                                }
                            </List>
                            {
                                searchResult.documents.totalRecords > GlobalSearchFirstPageRowsPerPage &&
                                <Link className={GlobalClassKeys.link} to={RoutePaths.FullDocumentSearch + this.props.location.search}><AppResource resource="Views.Search.FullGlobalSearch.ShowMoreDocuments" /></Link>
                            }
                        </MuiPaper>
                    </MuiContainer>
                }

                {
                    searchResult.documents.totalRecords > 0 && searchResult.publications.totalRecords > 0 &&
                    <MuiContainer>
                        <MuiPaper paperColor="white" className={this.props.classes.documentCard}>
                            <ListItem
                                button
                                onClick={
                                    (e) => {
                                        this.props.history.push(RoutePaths.FullDocumentSearch + this.props.location.search);
                                    }
                                }>
                                <Grid container wrap="nowrap" spacing={1}>
                                    <Grid item>
                                        <img src={AppImages.DefaultDocumentThumbnail} width={64} height={64} alt="Thumbnail" />
                                    </Grid>
                                    <Grid item xs>
                                        <div>
                                            <Typography color="secondary" variant="body1">
                                                {this.props.t("Views.Search.FullGlobalSearch.DocumentsTitle")}
                                            </Typography>
                                        </div>
                                        <MuiMuted>
                                            <Typography variant="caption">
                                                <Trans
                                                    i18nKey="Views.Search.FullGlobalSearch.DocumentsResult"
                                                    components={[<b></b>]}
                                                    values={{ count: searchResult.documents.totalRecords }}
                                                />
                                            </Typography>
                                        </MuiMuted>
                                    </Grid>
                                </Grid>
                            </ListItem>
                        </MuiPaper>
                    </MuiContainer>
                }
            </>
        );
    }

    private renderPublications() {
        const { searchResult, lastOffset } = this.state;
        if (searchResult.publications.totalRecords == 0) return null;

        return (
            <MuiContainer>
                <MuiPaper paperColor="white" className={this.props.classes.publicationCard}>
                    <List>
                        {
                            searchResult.publications.items.map((v, index) => {
                                return <SearchRenderPublication
                                    data={v}
                                    index={index}
                                    key={index}
                                    showDivider={false}
                                    querySearch={this.filter.searchText}
                                />;
                            })
                        }
                    </List>
                    {
                        searchResult.publications.totalRecords > GlobalSearchRowsPerPage &&
                        <MuiPagination
                            limit={GlobalSearchRowsPerPage}
                            offset={lastOffset}
                            total={searchResult.publications.totalRecords}
                            onClick={(e, offset) => this.loadPublications(offset)}
                        />
                    }
                </MuiPaper>
            </MuiContainer>
        );
    }

    private renderResult() {
        const { searchResult, loading, lastOffset } = this.state;

        if (loading) return null;

        return (
            <>
                {searchResult && lastOffset == 0 && this.firstPageRender()}

                {this.renderPublications()}
            </>
        );
    }

    private renderSearch() {

        const { searchResult, loading } = this.state;

        if (loading)
            return <SpinnerIndicator />;

        const total = searchResult.publications.totalRecords
            + searchResult.courses.totalRecords
            + searchResult.documents.totalRecords
            + searchResult.topics.totalRecords
            + searchResult.users.totalRecords;

        return (
            <>
                {
                    total > 0
                        ? (
                            <>
                                <MuiContainer margin="normal">
                                    <FilterCountInfo
                                        count={total}
                                        additionalInfo={`${this.props.t("Glossary.To")} "${this.filter.searchText}"`}
                                    />
                                </MuiContainer>
                                {this.renderResult()}
                            </>
                        )
                        : <MuiMessageBox variant="info" message={<AppResource resource="Views.Search.FullGlobalSearch.NoSearchResults" />} />
                }
            </>
        );
    }

    /////////////////////////////////////////////////////////////////////////////////////////////////

    public componentDidMount() {
        this.firstLoad();
    }

    public componentDidUpdate(prevProps: Props) {
        if (prevProps.location.search != this.props.location.search)
            this.reset(this.props);
    }

    public render() {
        const { dialog, lastError } = this.state;

        return (
            <div >
                {dialog}

                {this.renderAdvFilter()}

                {
                    lastError != null
                        ? <MuiMessageBox variant="error" message={lastError} />
                        : this.renderSearch()
                }
            </div>
        );
    }
}

/////////////////////////////////////////////////////////////////////////////////////////////////

const withAllStyles = withStyles(
    (theme) => ({
        ...FilterBarStyleClasses(theme),
        ...GlobalSearchStyleClasses(theme),
    }),
    { withTheme: true },
);


export default withTranslation()(withAllStyles(FullGlobalSearch));
